/* FAIRYDUST theme JS (v2 layout) */
(function(){
  /* prices in the shopper's currency, laid out exactly like Shopify's own money filter (symbol side, separators, decimals),
     read from a sample Liquid prints for this currency; whole amounts drop the ",00" (€36, $42, 403 kr, ¥6,500) */
  var MF = (function(){
    var s = String(window.FD_MONEY_SAMPLE || '€1.234.567,89');
    try{ var t=document.createElement('textarea'); t.innerHTML=s; s=t.value; }catch(e){}
    var a = s.search(/\d/), b = s.length-1; while(b>=0 && !/\d/.test(s.charAt(b))) b--;
    var mid = s.slice(a,b+1), m = mid.match(/^(.*?)([.,])(89)$/), ip = m ? m[1] : mid;
    return { pre:s.slice(0,a), suf:s.slice(b+1), dec:m?2:0, dp:m?m[2]:'.', th:(ip.match(/\D/)||[''])[0] };
  })();
  var money = function(c){ c=Math.round(c); var d=(MF.dec && c%100)?2:0; var p=(c/100).toFixed(d).split('.');
    return MF.pre+p[0].replace(/\B(?=(\d{3})+(?!\d))/g,MF.th)+(p[1]?MF.dp+p[1]:'')+MF.suf; };
  var FREE_SHIP = (window.FD_FREE_SHIP||5000);
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* text in the shopper's language (window.FD_T, from the theme's language files) and the language-aware root ('/' or '/de/') */
  var TT = window.FD_T || {}, R = window.FD_R || '/';
  function tr(k, d, o){ var s = TT[k] || d; if(o) for(var x in o) s = s.split('{'+x+'}').join(o[x]); return s; }
  /* arrival window from real deliveries (order to door): US 8-17 days, UK and Europe 8-18, elsewhere 10-21; made to order adds 7-14 */
  var EU_ZONE = ' AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB NO CH IS LI AD MC SM VA GI GG JE IM FO AX ';
  function etaDates(mto){ var cc=(window.Shopify&&Shopify.country)||'LV'; var r=cc==='US'?[8,17]:(EU_ZONE.indexOf(' '+cc+' ')>-1?[8,18]:[10,21]); if(mto) r=[r[0]+7,r[1]+14];
    var now=Date.now(), a=new Date(now+r[0]*864e5), b=new Date(now+r[1]*864e5), lang=document.documentElement.lang||'en';
    try{ var f=new Intl.DateTimeFormat(lang,{day:'numeric',month:'short'}); return f.formatRange?f.formatRange(a,b):f.format(a)+' – '+f.format(b); }catch(e){ return a.toLocaleDateString()+' – '+b.toLocaleDateString(); } }
  function etaText(key, def, mto){ return tr(key, def, {dates: etaDates(mto)}); }
  function bagMto(cart){ var m=window.FD_MTO||[]; return cart.items.some(function(it){ return m.indexOf(it.product_id)>-1; }); }

  /* ---------- Cart drawer ---------- */
  var lastFocus=null;
  function openDrawer(){ var d=$('#Drawer'); if(!d) return; lastFocus=document.activeElement; d.classList.add('is-on'); d.setAttribute('aria-hidden','false'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); document.body.style.overflow='hidden'; renderCart(); setTimeout(function(){ var x=$('[data-cart-close]',d); x&&x.focus(); },50); }
  function closeDrawer(){ var d=$('#Drawer'); if(!d) return; d.classList.remove('is-on'); d.setAttribute('aria-hidden','true'); $('#Overlay')&&$('#Overlay').classList.remove('is-on'); document.body.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&$('#Drawer')&&$('#Drawer').classList.contains('is-on')) closeDrawer(); });

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function cleanTitle(t){ return String(t||'').replace(/\s*\(made to order\)\s*/ig,' ').trim(); }
  function imgSize(u,w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u + (u.indexOf('?')>-1?'&':'?') + 'width='+w; }
  var PLUS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  /* ---------- Bag milestones: free shipping → tier 2 → tier 3 (+ free gift) ----------
     Amounts are set in euro (theme settings). Shoppers paying in another currency get them
     converted with Shopify's own exchange rate, the same way Shopify converts the shipping
     rate and discount minimums, so the bar and checkout agree. */
  var T = window.FD_TIERS || {ship:FREE_SHIP};
  var RATE = parseFloat(window.Shopify&&Shopify.currency&&Shopify.currency.rate)||1;
  function isGift(it){ return !!(it.properties&&it.properties._fd_gift); }
  function baseOf(cart){ return cart.items.reduce(function(s,it){ return isGift(it)?s:s+it.final_line_price; },0); }
  /* free shipping set to €0 = free on every order: it stays on the rail as a milestone already reached */
  function tierList(){
    return [['ship',T.ship,tr('ship_label','Free shipping'),tr('ship_phrase','free shipping')],['t2',T.t2,T.t2l,T.t2l],['t3',T.t3,T.t3l,T.t3l]]
      .filter(function(t){ return (t[1]>0||t[0]==='ship')&&t[2]; })
      /* at = Shopify's real converted minimum (decides unlocked / how much is left);
         show = the label, rounded UP to a whole unit in other currencies ($80.01 -> $81) */
      .map(function(t){ var at=Math.ceil(t[1]*RATE); return {k:t[0], at:at, show:RATE===1 ? at : Math.ceil(at/100)*100, label:t[2], phrase:t[3]}; });
  }
  /* the look of the bar lives in fd-tiers.js */
  function tiersHtml(amount){ return window.fdTiersHtml ? window.fdTiersHtml(amount,tierList(),{money:money,esc:esc,tr:tr}) : ''; }

  /* optional gift product added at the top milestone (off: FD_TIERS has no gift id, the gift is packed by hand) */
  var giftBusy=false;
  function syncGift(cart){
    if(giftBusy||!T.gift) return Promise.resolve(false);
    var lines=[]; cart.items.forEach(function(it,i){ if(isGift(it)) lines.push({line:i+1,qty:it.quantity}); });
    var want=(T.t3&&baseOf(cart)>=Math.ceil(T.t3*RATE))?1:0, req=null;
    if(want&&!lines.length) req=['/cart/add.js',{items:[{id:T.gift,quantity:1,properties:{_fd_gift:'1'}}]}];
    else if(lines.length&&(lines[0].qty!==want||lines.length>1)) req=['/cart/change.js',{line:lines[0].line,quantity:lines.length>1?0:want}];
    if(!req) return Promise.resolve(false);
    giftBusy=true;
    return fetch(req[0],{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(req[1])})
      .then(function(r){ giftBusy=false; return r.ok; }).catch(function(){ giftBusy=false; return false; });
  }

  /* discount codes: saved on the cart (Shopify carries them into checkout) */
  var lastCart=null;
  function codesOf(cart){ return ((cart&&cart.discount_codes)||[]).filter(function(d){ return d.applicable; }).map(function(d){ return d.code; }); }
  function saveCodes(list){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:list.join(',')})}).then(function(r){ if(!r.ok) throw 0; return r.json(); }); }
  function codeMsg(box,txt){ var m=$('.fd-code__msg',box); if(m){ m.textContent=txt; m.hidden=!txt; } }
  function paintCodes(cart){
    $all('[data-fd-code]').forEach(function(box){
      var c=$('.fd-code__chips',box); if(!c) return;
      c.innerHTML=codesOf(cart).map(function(code){ return '<span class="fd-code__chip">'+esc(code)+'<button type="button" data-code-rm="'+esc(code)+'" aria-label="'+esc(tr('remove_code','Remove code {code}',{code:code}))+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="17" y1="7" x2="7" y2="17"/><line x1="7" y1="7" x2="17" y2="17"/></svg></button></span>'; }).join('');
    });
  }
  function afterCodes(box){ if(box&&box.closest('#Drawer')) return renderCart(); location.reload(); }
  document.addEventListener('submit',function(e){
    var f=e.target.closest('.fd-code__f'); if(!f) return; e.preventDefault();
    var box=f.closest('[data-fd-code]'), inp=$('input',f), btn=$('button',f), code=inp.value.trim();
    if(!code){ inp.focus(); return; }
    var had=codesOf(lastCart);
    var CODE=code.toUpperCase();
    if(had.some(function(c){ return c.toUpperCase()===CODE; })){ codeMsg(box,tr('code_applied','“{code}” is already applied.',{code:CODE})); return; }
    btn.disabled=true; codeMsg(box,'');
    saveCodes(had.concat(code)).then(function(cart){
      var hit=(cart.discount_codes||[]).filter(function(d){ return d.code.toUpperCase()===CODE; })[0];
      if(hit&&hit.applicable){ inp.value=''; return afterCodes(box); }
      /* milestone rewards don't stack with codes: Shopify keeps whichever is better */
      var reward=(cart.cart_level_discount_applications||[]).some(function(d){ return (d.type||(d.discount_application||{}).type)==='automatic'; });
      return saveCodes(had).then(function(){ codeMsg(box, reward ? tr('code_combined','Codes can’t be combined with your bag reward, so we kept the better deal.') : tr('code_invalid','“{code}” can’t be used on this bag.',{code:CODE})); });
    }).catch(function(){ codeMsg(box,tr('error','Something went wrong, please try again.')); })
      .then(function(){ btn.disabled=false; });
  });
  document.addEventListener('click',function(e){
    var rm=e.target.closest('[data-code-rm]'); if(!rm) return;
    var code=rm.getAttribute('data-code-rm'), box=rm.closest('[data-fd-code]');
    rm.disabled=true;
    saveCodes(codesOf(lastCart).filter(function(c){ return c!==code; })).then(function(){ afterCodes(box); }).catch(function(){ rm.disabled=false; });
  });

  function setCount(n){ $all('.cartcount').forEach(function(el){ el.textContent=n; el.hidden=!n; }); }

  function renderCart(depth){
    depth=depth||0;
    return fetch(R+'cart.js').then(function(r){return r.json();}).then(function(cart){
      if(depth<2) return syncGift(cart).then(function(changed){ return changed?renderCart(depth+1):drawCart(cart); });
      return drawCart(cart);
    });
  }
  function drawCart(cart){
      lastCart=cart;
      setCount(cart.item_count);
      paintCodes(cart);
      var cnt=$('#DrawerCount'); if(cnt) cnt.textContent=cart.item_count?cart.item_count+' '+(cart.item_count===1?tr('item','item'):tr('items','items')):'';
      var ship=$('#DrawerShip'); if(ship){ var th=tiersHtml(baseOf(cart)); ship.hidden=!cart.item_count||!th; ship.className='fd-dship fd-tiers'; ship.innerHTML=th; }
      var body=$('#DrawerBody'), foot=$('#DrawerFoot');
      if(!body) return;
      if(cart.item_count===0){
        body.innerHTML='<div class="fd-dempty"><p class="fd-dempty__t">'+esc(tr('empty_title','Your bag is empty'))+'</p><p>'+esc(tr('empty_text','Have a look around, there is a little magic for everyone.'))+'</p><div class="fd-pills"><a class="fd-pill fd-pill--fill" href="'+R+'collections/all-products">'+esc(tr('shop_all','Shop all'))+'</a><a class="fd-pill" href="'+R+'collections/new-arrivals-1">'+esc(tr('new_in','New in'))+'</a></div></div>';
        if(foot) foot.hidden=true; return;
      }
      if(foot) foot.hidden=false;
      body.innerHTML='<ul class="fd-dlist">'+cart.items.map(function(it,i){
        var line=i+1, v=(it.variant_title&&it.variant_title!=='Default Title')?'<p class="fd-dline__v">'+esc(it.variant_title)+'</p>':'';
        var was=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
        var gift=isGift(it);
        return '<li class="fd-dline'+(gift?' fd-dline--gift':'')+'">'+
          '<a class="fd-dline__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(imgSize(it.image,200))+'" alt="" loading="lazy">':'')+'</a>'+
          '<div class="fd-dline__info">'+
            '<div class="fd-dline__top"><a class="fd-dline__t" href="'+esc(it.url)+'">'+esc(cleanTitle(it.product_title))+'</a><p class="fd-dline__p">'+(gift&&!it.final_line_price?'<s>'+money(it.original_line_price)+'</s>'+esc(tr('free','Free')):was+money(it.final_line_price))+'</p></div>'+v+
            (gift?'<p class="fd-dline__gift">'+esc(tr('free_gift','Your free gift'))+'</p>':
            '<div class="fd-dline__ctrl">'+
              '<span class="fd-step"><button type="button" data-line-qty="'+line+':'+(it.quantity-1)+'" aria-label="'+esc(tr('one_less','One less'))+'">−</button><span>'+it.quantity+'</span><button type="button" data-line-qty="'+line+':'+(it.quantity+1)+'" aria-label="'+esc(tr('one_more','One more'))+'">+</button></span>'+
              '<button type="button" class="fd-dline__rm" data-line-qty="'+line+':0">'+esc(tr('remove','Remove'))+'</button>'+
            '</div>')+
          '</div>'+
        '</li>';
      }).join('')+'</ul><div class="fd-dups" id="DrawerUpsell" hidden><p class="fd-dups__h">'+esc(tr('may_like','You may also like'))+'</p><div class="fd-dups__track" id="DrawerUpsellList"></div></div>';
      var offs=$('#DrawerOffs'); if(offs) offs.innerHTML=(cart.cart_level_discount_applications||[]).map(function(d){ return '<div class="fd-drawer__off"><span>'+esc(d.title)+'</span><span>−'+money(d.total_allocated_amount)+'</span></div>'; }).join('');
      var sub=$('#DrawerSubtotal'); if(sub) sub.textContent=money(cart.total_price);
      var co=$('#DrawerCheckout'); if(co) co.innerHTML=esc(tr('checkout','Checkout'))+' – <b>'+money(cart.total_price)+'</b>';
      var eta=$('#DrawerEta'); if(eta){ eta.textContent=etaText('eta_bag','Free delivery · arrives {dates}',bagMto(cart)); eta.hidden=false; }
      renderUpsell(cart);
  }

  /* bag page: milestones + code chips; reload if the free gift had to be added/removed */
  if($('#FdCartForm')){
    fetch(R+'cart.js').then(function(r){return r.json();}).then(function(cart){
      return syncGift(cart).then(function(changed){
        if(changed){ location.reload(); return; }
        lastCart=cart; paintCodes(cart);
        $all('[data-fd-eta]').forEach(function(el){ el.textContent=etaText('eta_bag','Free delivery · arrives {dates}',bagMto(cart)); el.hidden=false; });
        $all('[data-fd-tiers]').forEach(function(el){ el.innerHTML=tiersHtml(baseOf(cart)); el.hidden=!el.innerHTML; });
      });
    }).catch(function(){});
  }

  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-line-qty]');
    if(!q) return;
    e.preventDefault();
    var parts=q.getAttribute('data-line-qty').split(':');
    var row=q.closest('.fd-dline'); if(row) row.classList.add('is-busy');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(parts[0],10),quantity:Math.max(0,parseInt(parts[1],10))})})
      .then(function(r){return r.json();}).then(function(){ renderCart(); })
      .catch(function(){ if(row) row.classList.remove('is-busy'); });
  });

  var upsellCache={};
  function renderUpsell(cart){
    var wrap=$('#DrawerUpsell'), list=$('#DrawerUpsellList');
    if(!wrap||!list||!cart.items.length) return;
    var inCart={}; cart.items.forEach(function(i){inCart[i.product_id]=1;});
    var pid=cart.items[0].product_id;
    var get=function(intent){ var k=pid+intent; if(upsellCache[k]) return Promise.resolve(upsellCache[k]);
      return fetch(R+'recommendations/products.json?product_id='+pid+'&limit=8&intent='+intent).then(function(r){return r.json();}).then(function(d){ upsellCache[k]=d.products||[]; return upsellCache[k]; }).catch(function(){ return []; }); };
    get('complementary').then(function(a){ return a.length>=2?a:get('related').then(function(b){ return a.concat(b); }); })
      .then(function(all){
        var seen={}, items=all.filter(function(p){ if(inCart[p.id]||seen[p.id]||!p.available) return false; seen[p.id]=1; return true; }).slice(0,4);
        if(!items.length){ wrap.hidden=true; return; }
        list.innerHTML=items.map(function(p){
          var img=p.featured_image||(p.images&&p.images[0])||'';
          var single=p.variants&&p.variants.length===1;
          var btn=single?'<button type="button" class="fd-dup__add" data-quick-add="'+p.variants[0].id+'">'+PLUS+'<span>'+esc(tr('add','Add'))+'</span></button>':'<a class="fd-dup__add" href="'+esc(p.url)+'">'+PLUS+'<span>'+esc(tr('choose','Choose'))+'</span></a>';
          return '<div class="fd-dup"><a class="fd-dup__img" href="'+esc(p.url)+'">'+(img?'<img src="'+esc(imgSize(img,240))+'" alt="">':'')+'</a>'+
            '<div class="fd-dup__info"><a class="fd-dup__t" href="'+esc(p.url)+'">'+esc(cleanTitle(p.title))+'</a><span class="fd-dup__p">'+(p.price_varies?esc(tr('from','From'))+' ':'')+money(p.price)+'</span>'+btn+'</div></div>';
        }).join('');
        wrap.hidden=false;
      }).catch(function(){ wrap.hidden=true; });
  }

  /* product page: swap fallback cards for Shopify's own recommendations */
  $all('[data-recs-url]').forEach(function(w){
    var track=$('[data-recs-track]',w); if(!track) return;
    fetch(w.getAttribute('data-recs-url')).then(function(r){return r.text();}).then(function(html){
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var t=$('[data-recs-track]',tmp);
      if(t && t.children.length>=4){ track.innerHTML=t.innerHTML; track.scrollLeft=0; }
    }).catch(function(){});
  });

  window.fdRenderCart=renderCart; window.fdOpenCart=openDrawer;

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();}
    if(e.target.closest('[data-cart-close]')||e.target.id==='Overlay'){closeDrawer(); closeNav();}
    var qa=e.target.closest('[data-quick-add]');
    if(qa){ e.preventDefault(); var id=qa.getAttribute('data-quick-add'); if(!id||qa.classList.contains('is-busy'))return;
      var t=qa.innerHTML; qa.classList.add('is-busy');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ qa.classList.remove('is-busy');
        if(!r.ok){ qa.innerHTML='<span>'+esc(tr('sold_out','Sold out'))+'</span>'; setTimeout(function(){ qa.innerHTML=t; },1800); return; }
        if($('#Drawer')&&$('#Drawer').classList.contains('is-on')) renderCart(); else openDrawer(); })
      .catch(function(){ qa.classList.remove('is-busy'); qa.innerHTML=t; });
    }
  });

  /* ---------- Mobile nav ---------- */
  function closeNav(){ $('#NavDrawer')&&$('#NavDrawer').classList.remove('is-on'); if(!$('#Drawer')||!$('#Drawer').classList.contains('is-on')){ $('#Overlay')&&$('#Overlay').classList.remove('is-on'); } }
  document.addEventListener('click',function(e){
    if(e.target.closest('#Burger')){ $('#NavDrawer')&&$('#NavDrawer').classList.add('is-on'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); }
    if(e.target.closest('#NavClose')){ closeNav(); }
  });

  /* ---------- Announcement rotation ---------- */
  var annMsgs=$all('#FdAnn .fd-ann__msg');
  if(annMsgs.length>1 && !reduceMotion){
    var ai=0; setInterval(function(){ annMsgs[ai].classList.remove('is-on'); ai=(ai+1)%annMsgs.length; annMsgs[ai].classList.add('is-on'); },4000);
  }

  /* ---------- Header: overlay header becomes a floating bar after the hero ---------- */
  var head=$('#Head'), spacer=$('#HeadSpacer');
  if(head){
    var inFlow=!head.classList.contains('fd-head--over'), limit=inFlow?head.offsetTop+head.offsetHeight+40:160;
    var onScroll=function(){
      var stuck=window.scrollY>limit;
      if(stuck!==head.classList.contains('is-stuck')){
        if(inFlow&&spacer){ spacer.style.display=stuck?'block':'none'; spacer.style.height=stuck?(head.offsetHeight+13)+'px':'0'; }
        head.classList.toggle('is-stuck',stuck);
      }
    };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  /* ---------- Shop grid size toggle (remembered per browser) ---------- */
  var grid=$('#FdGrid'), gbtns=$all('[data-grid]');
  if(grid&&gbtns.length){
    var setGrid=function(n){ grid.classList.toggle('is-2',n==='2'); gbtns.forEach(function(b){ b.classList.toggle('is-on',b.getAttribute('data-grid')===n); }); try{ localStorage.setItem('fdGrid',n); }catch(e){} };
    gbtns.forEach(function(b){ b.addEventListener('click',function(){ setGrid(b.getAttribute('data-grid')); }); });
    try{ var saved=localStorage.getItem('fdGrid'); if(saved) setGrid(saved); }catch(e){}
  }

  /* ---------- Horizontal rails (product cards, photo row) ---------- */
  $all('[data-rail]').forEach(function(rail){
    var track=$('[data-rail-track]',rail); if(!track) return;
    var step=function(){ var c=track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap||0) : 300; };
    var prev=$('[data-rail-prev]',rail), next=$('[data-rail-next]',rail), bar=$('[data-rail-bar]',rail), dotsEl=$('[data-rail-dots]',rail);
    if(dotsEl){
      var n=track.children.length; dotsEl.innerHTML=Array(n+1).join('<span></span>'); var ds=$all('span',dotsEl); if(ds[0]) ds[0].classList.add('is-on');
      track.addEventListener('scroll',function(){ var i=Math.round(track.scrollLeft/step()); ds.forEach(function(d,k){ d.classList.toggle('is-on',k===Math.min(i,n-1)); }); },{passive:true});
    }
    prev&&prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:reduceMotion?'auto':'smooth'}); });
    next&&next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:reduceMotion?'auto':'smooth'}); });
    if(bar){
      var upd=function(){ var max=track.scrollWidth-track.clientWidth; var vis=track.clientWidth/track.scrollWidth; bar.style.width=Math.max(10,vis*100)+'%'; bar.style.transform='translateX('+(max>0?(track.scrollLeft/max)*((1/Math.max(vis,.1))-1)*100:0)+'%)'; };
      track.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
    }
  });

  /* ---------- Product page ---------- */
  var pdp=$('#Pdp');
  if(pdp && window.FD_VARIANTS){
    var variants=window.FD_VARIANTS, sel={};
    $all('[data-opt].is-active',pdp).forEach(function(b){ sel[b.getAttribute('data-opt')]=b.getAttribute('data-val'); });

    /* desktop gallery: clicking a side image shows it in the main frame */
    var mainImg=$('#FdGalMainImg'), thumbs=$all('.fd-gal__thumb');
    function showMedia(id){
      var t=thumbs.filter(function(x){return x.getAttribute('data-media-id')===String(id);})[0];
      if(t && mainImg && t.getAttribute('data-type')!=='video' && t.getAttribute('data-type')!=='external_video'){
        mainImg.style.opacity='0';
        setTimeout(function(){ mainImg.src=t.getAttribute('data-src'); mainImg.srcset=t.getAttribute('data-srcset'); mainImg.style.opacity='1'; },120);
      }
      thumbs.forEach(function(x){ x.classList.toggle('is-active',x===t); });
      var mt=$('#FdMobTrack'), slide=mt&&$('[data-media-id="'+id+'"]',mt);
      if(slide) mt.scrollTo({left:slide.offsetLeft,behavior:'auto'});
    }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ showMedia(t.getAttribute('data-media-id')); }); });
    var down=$('#FdGalDown'), list=$('#FdGalList');
    down&&list&&down.addEventListener('click',function(){ list.scrollBy({top:list.clientHeight*.8,behavior:'smooth'}); });

    /* mobile carousel dots */
    var mt=$('#FdMobTrack'), dots=$all('#FdMobDots span');
    if(mt&&dots.length){
      mt.addEventListener('scroll',function(){ var i=Math.round(mt.scrollLeft/mt.clientWidth); dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); },{passive:true});
    }

    /* rotating info bar */
    var infos=$all('#FdInfo .fd-info__m'), idots=$('#FdInfoDots');
    if(infos.length>1&&idots){
      idots.innerHTML=infos.map(function(_,k){return '<span'+(k===0?' class="is-on"':'')+'></span>';}).join('');
      var dd=$all('span',idots), ii=0;
      if(!reduceMotion) setInterval(function(){ infos[ii].classList.remove('is-on'); dd[ii].classList.remove('is-on'); ii=(ii+1)%infos.length; infos[ii].classList.add('is-on'); dd[ii].classList.add('is-on'); },3500);
    }

    /* side panels */
    var panel=$('#FdPanel'), scrim=$('#FdScrim'), ptitle=$('#FdPanelTitle'), lastBtn=null;
    function openPanel(key,btn){
      if(!panel) return; lastBtn=btn||null;
      $all('.fd-panel__sec',panel).forEach(function(s){ var on=s.getAttribute('data-sec')===key; s.hidden=!on; if(on&&ptitle) ptitle.textContent=s.getAttribute('data-title'); });
      panel.classList.add('is-on'); scrim&&scrim.classList.add('is-on'); document.body.style.overflow='hidden';
      var x=$('#FdPanelClose'); x&&x.focus();
    }
    function closePanel(){ if(!panel) return; panel.classList.remove('is-on'); scrim&&scrim.classList.remove('is-on'); document.body.style.overflow=''; lastBtn&&lastBtn.focus(); }
    $all('[data-panel]').forEach(function(b){ b.addEventListener('click',function(){ openPanel(b.getAttribute('data-panel'),b); }); });
    $('#FdPanelClose')&&$('#FdPanelClose').addEventListener('click',closePanel);
    scrim&&scrim.addEventListener('click',closePanel);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&panel&&panel.classList.contains('is-on')) closePanel(); });

    /* variants */
    var atc=$('#AtcBtn'), stickyBtn=$('#StickyAtcBtn'), disp=$('#FdDispatch');
    function dispEta(){ var m=disp.getAttribute('data-mto')==='true'; return m?etaText('eta_mto','Made to order · arrives {dates}',true):etaText('eta_in','In stock · arrives {dates}',false); }
    if(disp&&disp.getAttribute('data-avail')==='true') disp.textContent=dispEta();
    function currentVariant(){ return variants.filter(function(v){ return v.options.every(function(val,i){ return sel[i]==null||sel[i]===val; }); })[0]; }
    function applyVariant(){
      var v=currentVariant(); if(!v) return;
      $('#VariantId').value=v.id;
      var now=$('#PriceNow'), was=$('#PriceWas');
      if(now) now.textContent=money(v.price);
      if(was){ var on=v.compare_at_price>v.price; was.style.display=on?'':'none'; if(on) was.textContent=money(v.compare_at_price); }
      var sp=$('#StickyPrice'); if(sp) sp.textContent=money(v.price);
      var sku=$('#PdpSku'); if(sku) sku.textContent=v.sku||v.id;
      if(atc){ atc.disabled=!v.available; atc.innerHTML=v.available?esc(tr('add_to_bag','Add to bag'))+' – <b id="AtcPrice">'+money(v.price)+'</b>':esc(tr('sold_out','Sold out')); }
      if(stickyBtn){ stickyBtn.disabled=!v.available; stickyBtn.textContent=v.available?tr('add_to_bag','Add to bag'):tr('sold_out','Sold out'); }
      if(disp) disp.textContent=v.available?dispEta():disp.getAttribute('data-out');
      if(v.featured_media&&v.featured_media.id) showMedia(v.featured_media.id);
      if(window.history&&history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u.toString()); }
    }
    $all('[data-opt]',pdp).forEach(function(b){
      b.addEventListener('click',function(){
        var opt=b.getAttribute('data-opt');
        $all('[data-opt="'+opt+'"]',pdp).forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active'); sel[opt]=b.getAttribute('data-val');
        var lbl=$('#optval-'+opt); if(lbl) lbl.textContent=b.getAttribute('data-val');
        applyVariant();
      });
    });

    /* add to bag (AJAX + drawer); Shop Pay button submits natively */
    var form=$('#PdpForm');
    if(form) form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!atc||atc.disabled) return;
      var txt=atc.innerHTML; atc.textContent=tr('adding','Adding…'); atc.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt($('#VariantId').value,10),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ atc.innerHTML=txt; atc.disabled=false; openDrawer(); })
      .catch(function(){ atc.textContent=tr('try_again','Try again'); atc.disabled=false; });
    });

    /* sticky add bar (mobile) once the main button scrolls away */
    var box=$('#AtcBox'), sticky=$('#FdSticky');
    if(box&&sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ sticky.classList.toggle('is-on',!en[0].isIntersecting && en[0].boundingClientRect.top<0); },{threshold:0}).observe(box);
    }
    stickyBtn&&stickyBtn.addEventListener('click',function(){ if(!form)return; if(form.requestSubmit)form.requestSubmit(); else form.dispatchEvent(new Event('submit',{cancelable:true})); });
  }

  fetch(R+'cart.js').then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); });
})();
